// extracted by mini-css-extract-plugin
export default {"wrapper":"graphTwoType_wrapper__0km+-","btnWrapper":"graphTwoType_btnWrapper__sobTw","dataBtnWrapper":"graphTwoType_dataBtnWrapper__zLHC9"};